import type { SketchPickerProps} from 'react-color';
import {SketchPicker} from 'react-color'
import React, {useMemo, useState} from 'react'
import {usePopper} from 'react-popper'
import BodyEnd from '../BodyEnd'
import useEvent from '../../hooks/useEvent'
import css from './AioColorPicker.less'
import {rgbHexToLightness} from '../../helpers/color'
import {useClickOutsideHandler} from '../../hooks/useClickOutsideHandler'


type ColorPickerProps = Override<SketchPickerProps, {
    text: string
    label: string
    color: string
}>


export function AioColorPicker({text,label,...props}: ColorPickerProps) {
    const [containerRef,setContainerRef] = useState<HTMLElement|null>(null)
    const [popupRef,setPopupRef] = useState<HTMLElement|null>(null)
    const popper = usePopper(containerRef, popupRef, {placement: 'bottom-start',modifiers:[
            {
                name: 'offset',
                options: {
                    offset: [0,2],
                }
            },
        ]})
    const [colorPickerOpen, setColorPickerOpen] = useState(false)

    const onOpen = useClickOutsideHandler(() => {
        setColorPickerOpen(false)
    }, [popupRef])

    const openColorPicker = useEvent(() => {
        if(!colorPickerOpen) {
            onOpen()
            setColorPickerOpen(true)
        }
    })

    const bgColor = props.color || '#CCCFDB';
    const bgIsLight = useMemo(() => rgbHexToLightness(bgColor) > 80, [bgColor])
    const fgColor = bgIsLight ? '#000' : '#fff'
    const borderColor = bgIsLight ? '#CCCFDB' : bgColor

    return <>
        <div className={css.wrapper} ref={setContainerRef} onClick={openColorPicker}>
            <div>
                <div className={css.label}>{label || "Color"}</div>
                <span className={css.button} style={{backgroundColor:bgColor,color:fgColor,borderColor}}>{text}</span>
            </div>
        </div>
        {colorPickerOpen ? <BodyEnd>
            <div ref={setPopupRef} className={css.popper} {...popper.attributes.popper} style={popper.styles.popper}>
                <SketchPicker {...props} />
            </div>
        </BodyEnd> : null}
    </>
}
